export enum ActivityCreateScreen {
  CreateHome = "create-home",
  CreateConnect = "create-connect",
  CreateDetails = "create-details",
  CreateAttributes = "create-attributes",
  CreateBatch = "create-batch",
}

export interface ActivityCreateProps {
  onScreenChange: (screen: ActivityCreateScreen) => void
  onBack: () => void
  onChange: () => void
  onClose: () => void
}

